import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "features/Application/slices/createFetchingItemsSlice";
import { type CampaignOverview } from "../../types/state";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { fetchOverviewCampaigns } from "../thunks/campaignOverviewThunk";

export type CampaignOverviewState = FetchingItemsState<CampaignOverview>;

export const initialState: CampaignOverviewState = {
  areAllLoaded: false,
  isLoading: false,
  items: [],
  itemsCount: 0,
  currentRequestId: "",
};

const campaignOverviewSlice = createFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.ThreatDefenceCampaigns,
    name: "overview",
  },
  initialState,
  reducers: {},
  thunk: fetchOverviewCampaigns,
});

export const { reset, fetchFailure } = campaignOverviewSlice.actions;

export const reducer = campaignOverviewSlice.reducer;
